import { render, staticRenderFns } from "./bzqy.vue?vue&type=template&id=231df1c9&scoped=true&"
import script from "./bzqy.vue?vue&type=script&lang=js&"
export * from "./bzqy.vue?vue&type=script&lang=js&"
import style0 from "./bzqy.vue?vue&type=style&index=0&id=231df1c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231df1c9",
  null
  
)

export default component.exports